import React, { useEffect, useState } from 'react'
import { Autocomplete, FormControl, TextField } from '@mui/material'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { onlyNumeric } from '../../../../../../../commonClass/CommonValidation';
import { postUsersData, verifytoken } from '../../../../../../../../services/ApiCallingUserServices';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../../../../../../_actions/loader.actions';
import { ClearLocalStorage } from '../../../../../../../commonClass/Session';
import { hotelRateInventoryOpen } from '../../../../../../../../_actions/user.action';

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = '' + d.getFullYear()

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return date === null ? "" : [day, month, year].join('/');
}

function formFormatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return date === null ? null : [year, month, day].join('-');
}

const InventoryModal = (props) => {
    const { title,
        isEdit,
        roomId,
        selectedCellDate,
        RoomAvailabilityDates,
        setOpenModal,
        roomlist,
        dayRangeList,
        HotelBasicId,
        UserId,
    } = props;

    const dispatch = useDispatch();
    const [dateRangeValue, setDateRangeValue] = useState('');
    const [closedMessage, setClosedMessage] = useState('');
    const [isSave, setIsSave] = useState(true);
    const [formValue, setFormValue] = useState({
        RoomType: roomId,
        FromDate: formFormatDate(selectedCellDate) || "",
        ToDate: formFormatDate(selectedCellDate) || "",
        FromDateSelect: selectedCellDate || null,
        ToDateSelect: selectedCellDate || null,
        Days: 0,
        ETMAllocation: null,
        OnHold: null,
        HotelBasicId: HotelBasicId,
        UserId: UserId,
    });
    const [formError, setFormError] = useState({});
    const [apiError, setApiError] = useState('')


    useEffect(() => {
        if (selectedCellDate !== null) {
            setDateRangeValue(`${formatDate(new Date(selectedCellDate))}`)
        }
    }, [selectedCellDate])

    const onChange = (name, value) => {
        setIsSave(false);
        setFormError({});
        setApiError('');
        setFormValue(form => ({ ...form, [name]: value }))
    }

    const handleDateRange = (update, isEdit) => {
        setFormError({});
        setIsSave(false);
        setApiError('');
        if (isEdit) {
            setFormValue(form => ({
                ...form,
                FromDate: formFormatDate(update),
                FromDateSelect: update,
            }))
            setDateRangeValue(`${formatDate(update)}`)
        }
        else {
            setFormValue(form => ({
                ...form,
                FromDate: formFormatDate(update[0]),
                FromDateSelect: update[0],
                ToDate: formFormatDate(update[1]),
                ToDateSelect: update[1],
            }))
            setDateRangeValue(`${formatDate(update[0])} - ${formatDate(update[1])}`)
        }
    }

    const openDatePicker = (e) => {
        //open date picker on click date icon 
        document.querySelector("#" + e).click();
    };

    const onClose = () => {
        isSave ? setOpenModal(false) : setClosedMessage(true);
    }

    const YesProceed = (e) => {
        e.preventDefault()
        setOpenModal(false)
        setClosedMessage(false)
    }

    const NoProceed = (e) => {
        e.preventDefault()
        setClosedMessage(false)
    }

    const validateData = () => {
        let status = true;
        let error = {};

        if (isEdit) {
            if (formValue?.FromDateSelect === null) {
                error["date"] = "Date selection is mandatory.";
                status = false;
            }
        }
        else {
            if (formValue?.FromDateSelect === null || formValue?.ToDateSelect === null) {
                error["date"] = "Date selection is mandatory.";
                status = false;
            }

            if (formValue?.Days <= 0) {
                error["Days"] = "Input is mandatory.";
                status = false;
            }
        }

        if (formValue?.ETMAllocation === null) {
            error["ETMAllocation"] = "Input is mandatory.";
            status = false;
        }
        setFormError(error)

        return status;
    }

    //#region API getchannelmanagerlist
    const getDayInventary = async () => {
        const dayInventoryDetails = await postUsersData('/master/v1/gethotelinventorybyhotelroomid', {
            HotelRoomId: formValue?.RoomType,
            InventoryDate: formFormatDate(formValue?.FromDateSelect)
        });

        if (dayInventoryDetails.status) {
            setFormValue((pre) => ({
                ...pre,
                ETMAllocation: dayInventoryDetails?.data.InventoryStock,
                OnHold: dayInventoryDetails?.data.BlackOut,
            }))
        }
    };

    //#region Fetch all API data
    //using Promise.all to run them in parallel
    useEffect(() => {

        const fetchDropDownData = async () => {
            dispatch(loaderActions.start());
            let statusoftoken = await verifytoken();

            if (statusoftoken) {
                try {
                    formValue?.FromDateSelect && await getDayInventary();
                } catch (error) {
                    console.error('Error during fetching data:', error);
                } finally {
                    dispatch(loaderActions.end());
                }
            } else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
            }
        };

        isEdit && formValue?.FromDateSelect && fetchDropDownData();
    }, [formValue?.FromDateSelect, isEdit]);


    const updateInventary = async () => {
        const inventory = await postUsersData('/master/v1/insertupdatehotelinventory',
            {
                HotelBasicId: formValue?.HotelBasicId,
                HotelRoomId: formValue?.RoomType,
                InventoryDate: formFormatDate(formValue?.FromDateSelect),
                InventoryStock: formValue?.ETMAllocation,
                BlackOut: formValue?.OnHold,
                UserId: formValue?.UserId
            }
        );

        if (inventory.status) {
            setOpenModal(false);
            setFormError({})
            setIsSave(true);
            dispatch({ type: 'ALERTING', message: inventory.message });
            sessionStorage.setItem('latestStep', sessionStorage?.getItem('latestStep') >= "5" ? Number(sessionStorage?.getItem('latestStep')) : 5);
            dispatch(hotelRateInventoryOpen())
        } else {
            setApiError(inventory.message)
        }
    };

    const updateBulkInventary = async () => {
        const bulkInventory = await postUsersData('/master/v1/insertbulkupdateinventory',
            {
                HotelBasicId: formValue?.HotelBasicId,
                HotelRoomId: formValue?.RoomType,
                DayRangesId: formValue?.Days,
                InventoryStock: formValue?.ETMAllocation,
                BlackOut: formValue?.OnHold,
                UserId: formValue?.UserId,
                FromDate: formValue?.FromDate,
                ToDate: formValue?.ToDate
            },
        );

        if (bulkInventory.status) {
            setOpenModal(false);
            setFormError({})
            setIsSave(true);
            dispatch({ type: 'ALERTING', message: bulkInventory.message });
            sessionStorage.setItem('latestStep', sessionStorage?.getItem('latestStep') >= "5" ? Number(sessionStorage?.getItem('latestStep')) : 5);
            dispatch(hotelRateInventoryOpen())
        } else {
            setApiError(bulkInventory.message)
        }
    };

    const handleApply = (e) => {
        e.preventDefault();
        if (validateData()) {
            if (isEdit) {
                updateInventary()
            } else {
                updateBulkInventary()
            }

        }
    }

    return (
        <>
            <div className="d-flex justify-content-between align-items-center bulk_update_modal_header">
                <div className="bulk_update_modal_title">
                    {title}
                </div>
                <div role='button' onClick={onClose}>
                    <i class="fa-solid fa-xmark"></i>
                </div>
            </div>
            {closedMessage &&
                <div className="text-center pb-3">
                    <span className="text-danger">Unsaved data, do you want to close the window ? </span>
                    <span role='button' style={{ color: '#0777A9' }} onClick={(e) => YesProceed(e)} > Yes </span>
                    or
                    <span role='button' style={{ color: '#0777A9' }} onClick={(e) => NoProceed(e)} > No</span>.
                </div>
            }
            <form action="" className='py-2'>

                <div className='row'>
                    {
                        !isEdit &&
                        <div className="col-12 mb-4">
                            <FormControl fullWidth>
                                <Autocomplete
                                    clearIcon={false}
                                    options={roomlist?.filter((item) => item?.id !== formValue?.RoomType)}
                                    id="select-roomtype-inventory"
                                    value={roomlist?.find((obj) => obj?.id === formValue?.RoomType) || null}
                                    name='RoomType'
                                    onChange={(e, newValue) => onChange("RoomType", newValue?.id)}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Room Type"
                                            className={`${formValue?.RoomType <= 0 ? 'red_border' : ''}`}
                                        />
                                    )}
                                    disabled
                                />
                            </FormControl>
                        </div>
                    }

                    <div className="col-12 mb-4">
                        <div className="row">
                            <div className={`${isEdit ? 'col-12 lengthfull' : 'col-6'} `}>
                                <div className="text-container">
                                    <TextField
                                        fullWidth
                                        id="select-date"
                                        label={`${isEdit ? "Select Date" : "Date Range (From-To)"}`}
                                        value={dateRangeValue}
                                        onClick={(e) => openDatePicker("selectdate")}
                                        disabled={selectedCellDate !== null}
                                        className={`${(isEdit ? formValue?.FromDateSelect !== null : (formValue?.FromDateSelect !== null && formValue?.ToDateSelect !== null)) ? '' : 'red_border'}`}
                                        error={formError?.date ? true : false}
                                        helperText={formError?.date}
                                        autoComplete='off'
                                    />
                                    <div>
                                        {
                                            isEdit ?
                                                <DatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    className='form-control d-none'
                                                    id='selectdate'
                                                    selected={formValue?.FromDateSelect}
                                                    placeholderText="Select Date"
                                                    autoComplete='off'
                                                    showMonthDropdown
                                                    startDate={formValue?.FromDateSelect}
                                                    onChange={(e) => handleDateRange(e, isEdit)}
                                                    minDate={new Date() < new Date(RoomAvailabilityDates?.StartDate) ? new Date(RoomAvailabilityDates?.StartDate) : new Date()}
                                                    maxDate={new Date(RoomAvailabilityDates?.EndDate)}
                                                />
                                                :
                                                <DatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    className='form-control d-none'
                                                    id='selectdate'
                                                    selected={formValue?.FromDateSelect}
                                                    placeholderText="Date Range (From-To)"
                                                    selectsRange={true}
                                                    autoComplete='off'
                                                    showMonthDropdown
                                                    startDate={formValue?.FromDateSelect}
                                                    endDate={formValue?.ToDateSelect}
                                                    onChange={(e) => handleDateRange(e, isEdit)}
                                                    minDate={new Date() < new Date(RoomAvailabilityDates?.StartDate) ? new Date(RoomAvailabilityDates?.StartDate) : new Date()}
                                                    maxDate={new Date(RoomAvailabilityDates?.EndDate)}
                                                />
                                        }

                                    </div>
                                    <span className={`example-custom-input bulkCalendarBtn ${selectedCellDate !== null ? 'disableCalBtn' : ''}`}
                                        onClick={(e) => openDatePicker("select-date")}
                                    ><i className="fa fa-calendar"></i></span>
                                </div>
                            </div>
                            {
                                !isEdit &&
                                <div className="col-6">
                                    <FormControl fullWidth>
                                        <Autocomplete
                                            clearIcon={false}
                                            options={dayRangeList?.filter((item) => item?.id !== formValue?.Days)}
                                            id="select-days"
                                            value={dayRangeList?.find((obj) => obj?.id === formValue?.Days) || null}
                                            name='Days'
                                            onChange={(e, newValue) => onChange("Days", newValue?.id ? newValue?.id : null)}
                                            renderInput={(params) => (
                                                <TextField {...params} label="Days"
                                                    className={`${(formValue?.Days <= 0) ? 'red_border' : ''}`}
                                                    error={formError?.Days ? true : false}
                                                    helperText={formError?.Days}
                                                    autoComplete='off'
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </div>
                            }
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="row">
                            <div className="col-6">
                                <TextField
                                    fullWidth
                                    type='text'
                                    className={`${formValue.ETMAllocation === null ? 'red_border' : ''}`}
                                    id="available-quantity"
                                    label="ETM Allocation"
                                    name='ETMAllocation'
                                    value={formValue?.ETMAllocation || ''}
                                    onChange={(e) => onChange(e.target.name, e.target.value === "" ? null : Number(onlyNumeric(e.target.value)))}
                                    error={formError?.ETMAllocation ? true : false}
                                    helperText={formError?.ETMAllocation}
                                    autoComplete='off'
                                    disabled={isEdit && !formValue?.FromDateSelect ? true : false}
                                />
                            </div>
                            <div className="col-6">
                                <TextField
                                    fullWidth
                                    id="on-hold"
                                    label="On Hold"
                                    name='OnHold'
                                    value={formValue?.OnHold || ''}
                                    onChange={(e) => onChange(e.target.name, e.target.value === "" ? null : Number(onlyNumeric(e.target.value)))}
                                    autoComplete='off'
                                    disabled={isEdit && !formValue?.FromDateSelect ? true : false}
                                />
                            </div>
                        </div>
                    </div>

                    {/* {
                        isEdit &&
                        <div className="col-12 mb-4">
                        <div className="row">
                        <div className="col-6">
                        <TextField
                        fullWidth
                        id="booked"
                                        label="Booked"
                                        name='Booked'
                                        value={0}
                                        disabled
                                    />
                                </div>
                                <div className="col-6">
                                    <TextField
                                        fullWidth
                                        id="open"
                                        label="Open"
                                        name='Open'
                                        value={0}
                                        disabled
                                    />
                                </div>
                            </div>
                        </div>
                    } */}

                    {apiError && <span className='text-danger text-center mt-2'>{apiError}</span>}
                    <div className="col-12 mt-4">
                        <button type="button" className='btn bulk_apply_btn btn-primary w-100' onClick={(e) => handleApply(e)} >Apply</button>
                    </div>
                </div>
            </form>

        </>
    )
}

export default InventoryModal
